var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 79.5,
    r: 79.5,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Oval.3dc97d995f8c308c7c7dfb8b7a39a078.svg";